import { c as _c } from "react/compiler-runtime";
import { InputWrapper, SelectWrapper } from "@/src/components/tasks/input-wrapper";
import { EntityMatcher } from "@/src/components/tasks/intake-sections/matchers";
import { Hyperlink } from "@/src/components/typography";
import { EnabledFields } from "@/src/lib/schema-types";
import { stateOptions } from "@/src/lib/us-states";
import { enumToOptions, getNestedValue, isFieldEnabled } from "@/src/lib/utils/object-utils";
import { FacilityType } from "@/src/models/constants/facility-types";
import { type Location, type LocationErrors, type LocationFieldKey, LocationRole } from "@/src/models/location";
interface LocationFormProps {
  // Base props
  location: Location;
  onChange: (field: LocationFieldKey, value: string) => void;
  createMode?: boolean;
  errors?: LocationErrors;

  // location-section props
  matchedLocation?: Location | null;
  locationObjString?: string;
  requiredFields?: string[];
  conflictingFields?: string[];
  enabledFields?: EnabledFields;
  onSave?: () => void;
  onFocus?: (metadata?: any) => void;
  onFlagForInaccuracyUpdate?: (key: string, value: any) => void;
  metadata?: any;

  // LocationMatcher props
  locations?: Location[];
  isLocationsLoading?: boolean;
  onLocationSelected?: (location: Location | null) => void;
  showLocationMatcher?: boolean;
  onEmptyToggle?: () => void;
}
export default function LocationForm(t0) {
  const $ = _c(46);
  const {
    location,
    onChange,
    createMode: t1,
    errors: t2,
    matchedLocation,
    locationObjString,
    requiredFields: t3,
    conflictingFields: t4,
    enabledFields,
    onSave,
    onFocus,
    onFlagForInaccuracyUpdate,
    metadata,
    locations,
    isLocationsLoading,
    onLocationSelected,
    showLocationMatcher: t5,
    onEmptyToggle
  } = t0;
  const createMode = t1 === undefined ? false : t1;
  let t6;
  if ($[0] !== t2) {
    t6 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const errors = t6;
  let t7;
  if ($[2] !== t3) {
    t7 = t3 === undefined ? [] : t3;
    $[2] = t3;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const requiredFields = t7;
  let t8;
  if ($[4] !== t4) {
    t8 = t4 === undefined ? [] : t4;
    $[4] = t4;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const conflictingFields = t8;
  const showLocationMatcher = t5 === undefined ? false : t5;
  let t9;
  if ($[6] !== onChange) {
    t9 = (fieldKey, value) => {
      onChange(fieldKey, value);
    };
    $[6] = onChange;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const handleFieldChange = t9;
  let t10;
  if ($[8] !== metadata) {
    t10 = fieldKey_0 => getNestedValue(metadata, fieldKey_0 + "_metadata");
    $[8] = metadata;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const getFieldMetadata = t10;
  let t11;
  if ($[10] !== conflictingFields || $[11] !== errors || $[12] !== getFieldMetadata || $[13] !== handleFieldChange || $[14] !== location || $[15] !== locationObjString || $[16] !== matchedLocation || $[17] !== onFlagForInaccuracyUpdate || $[18] !== onFocus || $[19] !== onSave || $[20] !== requiredFields) {
    t11 = t12 => {
      const {
        fieldKey: fieldKey_1,
        label,
        type: t13,
        options,
        placeholder,
        readonly: t14
      } = t12;
      const type = t13 === undefined ? "text" : t13;
      const readonly = t14 === undefined ? false : t14;
      const value_0 = getNestedValue(location, fieldKey_1) ?? "";
      const secondaryValue = getNestedValue(matchedLocation, fieldKey_1) ?? "";
      const error = getNestedValue(errors, fieldKey_1) ?? null;
      const fullFieldKey = locationObjString ? `${locationObjString}.${fieldKey_1}` : fieldKey_1;
      const isRequired = requiredFields.includes(fullFieldKey);
      const doesConflict = conflictingFields.includes(fieldKey_1);
      if (type === "select" && options) {
        return <div key={fieldKey_1}><SelectWrapper value={value_0} secondaryValue={secondaryValue} onChange={newValue => handleFieldChange(fieldKey_1, newValue)} label={label} disabled={readonly} placeholder={placeholder} options={options} onFocus={() => onFocus?.(getFieldMetadata(fieldKey_1))} onBlur={onSave} doesConflict={doesConflict} onFlagForInaccuracyUpdate={onFlagForInaccuracyUpdate} fieldKey={fullFieldKey} />{error && <p className="text-xs text-red-500 mt-1 ml-1">{error}</p>}</div>;
      }
      return <div key={fieldKey_1}><InputWrapper type={type} value={value_0} secondaryValue={secondaryValue} onChange={e => handleFieldChange(fieldKey_1, e.target.value)} label={label} placeholder={placeholder} isRequired={isRequired} onSave={onSave} readOnly={readonly} onFocus={() => onFocus?.(getFieldMetadata(fieldKey_1))} doesConflict={doesConflict} onFlagForInaccuracyUpdate={onFlagForInaccuracyUpdate} fieldKey={fullFieldKey} error={error} /></div>;
    };
    $[10] = conflictingFields;
    $[11] = errors;
    $[12] = getFieldMetadata;
    $[13] = handleFieldChange;
    $[14] = location;
    $[15] = locationObjString;
    $[16] = matchedLocation;
    $[17] = onFlagForInaccuracyUpdate;
    $[18] = onFocus;
    $[19] = onSave;
    $[20] = requiredFields;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const renderField = t11;
  const hasLocationInfoEnabled = ["name", "phoneNumber", "faxPhoneNumber", "ehrId", "facilityType"].some(field => isFieldEnabled(enabledFields, `${locationObjString}.${field}`));
  let t12;
  if ($[22] !== createMode || $[23] !== enabledFields || $[24] !== locationObjString) {
    t12 = createMode && isFieldEnabled(enabledFields, `${locationObjString}.role`);
    $[22] = createMode;
    $[23] = enabledFields;
    $[24] = locationObjString;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const hasRoleEnabled = t12;
  const hasAddressInfoEnabled = ["address.line1", "address.line2", "address.city", "address.state", "address.postalCode", "address.country"].some(field_0 => isFieldEnabled(enabledFields, `${locationObjString}.${field_0}`));
  let t13;
  if ($[26] !== createMode || $[27] !== errors || $[28] !== isLocationsLoading || $[29] !== locations || $[30] !== matchedLocation || $[31] !== onEmptyToggle || $[32] !== onLocationSelected || $[33] !== showLocationMatcher) {
    t13 = (showLocationMatcher || createMode) && onLocationSelected && <div><div className="flex justify-center items-center mb-2 gap-2"><div className="w-[70%]"><EntityMatcher type="location" existingEntities={createMode ? [] : locations} isLoadingExistingEntities={createMode ? false : isLocationsLoading} entity={matchedLocation || null} onEntitySelected={onLocationSelected} /></div>{onEmptyToggle && <div className="flex items-center gap-2"><Hyperlink onClick={onEmptyToggle} href="#" className="text-xs">Empty</Hyperlink></div>}</div>{errors.placeId && <p className="text-xs text-red-500 text-center">{errors.placeId}</p>}</div>;
    $[26] = createMode;
    $[27] = errors;
    $[28] = isLocationsLoading;
    $[29] = locations;
    $[30] = matchedLocation;
    $[31] = onEmptyToggle;
    $[32] = onLocationSelected;
    $[33] = showLocationMatcher;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== hasLocationInfoEnabled || $[36] !== renderField) {
    t14 = hasLocationInfoEnabled && <div><div className="grid grid-cols-12 gap-4"><div className="col-span-12">{renderField({
            fieldKey: "name",
            label: "Location Name"
          })}</div><div className="col-span-6">{renderField({
            fieldKey: "phoneNumber",
            label: "Phone Number",
            type: "tel",
            placeholder: "555-123-4567"
          })}</div><div className="col-span-6">{renderField({
            fieldKey: "faxPhoneNumber",
            label: "Fax Number",
            type: "tel",
            placeholder: "555-123-4567"
          })}</div><div className="col-span-6">{renderField({
            fieldKey: "ehrId",
            label: "EHR ID"
          })}</div><div className="col-span-6">{renderField({
            fieldKey: "facilityType",
            label: "Facility Type",
            type: "select",
            options: enumToOptions(FacilityType)
          })}</div></div></div>;
    $[35] = hasLocationInfoEnabled;
    $[36] = renderField;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== hasAddressInfoEnabled || $[39] !== hasRoleEnabled || $[40] !== renderField) {
    t15 = hasAddressInfoEnabled && <div><h3 className="text-sm font-semibold mb-3 text-muted-foreground">Address Information</h3><div className="grid grid-cols-12 gap-4"><div className="col-span-12">{renderField({
            fieldKey: "address.line1",
            label: "Street Address",
            placeholder: "123 Main St",
            readonly: true
          })}</div><div className="col-span-12">{renderField({
            fieldKey: "address.line2",
            label: "Street Address Line 2",
            placeholder: "Apt 100, Suite 200, etc.",
            readonly: true
          })}</div><div className="col-span-4">{renderField({
            fieldKey: "address.city",
            label: "City",
            readonly: true
          })}</div><div className="col-span-4">{renderField({
            fieldKey: "address.state",
            label: "State",
            type: "select",
            options: stateOptions,
            placeholder: "Select a state",
            readonly: true
          })}</div><div className="col-span-4">{renderField({
            fieldKey: "address.postalCode",
            label: "Zip Code",
            placeholder: "12345",
            readonly: true
          })}</div><div className="col-span-12">{renderField({
            fieldKey: "address.country",
            label: "Country",
            placeholder: "USA",
            readonly: true
          })}</div></div>{hasRoleEnabled && <div className="grid grid-cols-1 gap-4 mt-4">{renderField({
          fieldKey: "role",
          label: "Role",
          type: "select",
          options: enumToOptions(LocationRole)
        })}</div>}</div>;
    $[38] = hasAddressInfoEnabled;
    $[39] = hasRoleEnabled;
    $[40] = renderField;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== t13 || $[43] !== t14 || $[44] !== t15) {
    t16 = <div className="space-y-6">{t13}{t14}{t15}</div>;
    $[42] = t13;
    $[43] = t14;
    $[44] = t15;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  return t16;
}